import React from "react";
import { cn } from "../../utils/cn";

interface SkeletonProps {
  className?: string;
}

/** A shimmering placeholder block — size and shape it with className (e.g. "h-4 w-32 rounded-full"). */
const Skeleton: React.FC<SkeletonProps> = ({ className }) => (
  <div className={cn("animate-shimmer rounded-md", className)} />
);

export default Skeleton;
